import React, {useContext} from 'react';
import IconBase from './IconBase';
import {BrandContext} from "../BrandContext";

const QuestionSetIcon = props => {
    const brandConfig = useContext(BrandContext);
    return (
        <IconBase {...props} defaultTooltipTitle={brandConfig.questionsName} useTag={'<use xlink:href="#questionSet-icon"/>'} viewBox={'0 0 128 128'}>
        </IconBase>
    )
}

export default QuestionSetIcon;